import api from "./axios";
export const catalogApi = {
    getServices(params) {
        return api.get("/catalog/services", { params });
    },
    getService(id) {
        return api.get(`/catalog/services/${id}`);
    },
    getServiceReviews(serviceId, params) {
        return api.get(`/api/v2/catalog/services/${serviceId}/reviews`, { params });
    },
};
export default catalogApi;
